import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import useConfiguration from "../../../../hooks/useConfiguration";
import useSessionStorage from "../../../../hooks/useSessionStorage";
import Footer from "../../../common/Footer";
import Header from "../../../common/Header";
import Loader from "../../../common/Loader";
import Sidebar from "../../../common/Sidebar";
import Spinner from "../../../common/Spinner/spinner";
import {
  clearData,
  getCandidateLocationStatus,
  getCandidateRating,
  getCandidateSearchViewDetail,
  loadMasterData,
  setCandidateRating,
  updateCandidateFavorites,
  updateCandidateStatus,
  sendEmail,
  sendSMS,
  getEmailDetails,
  getSMSDetails,
  sendAllEmailbtn,
  sendAllSmsbtn,
  getCallHistory
} from "./action";
import { candidateSearchViewSelector } from "./selector";
import { setcandidateRating } from "./slice";

import ReactStars from "react-rating-stars-component";
import StarRating from "../../../common/StarRating";
import * as Toasts from "../../../common/Toastify";
import { updateStatus } from "../NewCandidateSearch/action";
import Covid19vaccinated from "./covid19vaccinated";
import EmergencyContact from "./emergencyContact";
import EmrandehrSystem from "./emrandehrSystem";
import LevelOfEducation from "./levelOfEducation";
import Positions from "./positions";
import PreferredShifts from "./preferredShifts";
import PreferredWorkDays from "./preferredWorkDays";
import RegistrationForm from "./registrationForm";
import ResumeUpload from "./resumeUpload";
import TravelDistance from "./travelDistance";
import Willingworkholidays from "./willingworkholidays";
import YourReferences from "./yourReferences";
import YourSpecialties from "./yourSpecialties";
// import { Rating } from 'react-simple-star-rating';
import Overallratingstatus from "../../../common/StarRating/overallratingstatus";

import { toast } from "react-toastify";
import CandidateStatusTable from "./CandidateStatusTable";
import CandidateStatusUpdate from "./CandidateStatusUpdate";
import CommentSummry from "./CommentSummry";
import QandaTaForm from "./qanadaSummery";

import Modal from "../../../common/Modal/modal";
import SpokenLanguage from "./spokenLanguage";
import NewCertifications from "./NewCertifications";
import BackFixedButton from "../../../common/BackFixedButton/BackFixedButton";
import EmployerUploads from "./employerUploads";
import Relocate from "./relocate";
import EmailModal from "../../../common/Modal/EmailModal";
import SMSModal from "../../../common/Modal/SMSModal";
import CallModal from "../../../common/Modal/CallModal";
import CandidateDepartments from "./CandidateDepartments";
import DepsUnitsModal from "../../../common/Modal/DepsUnitsModal";
import Hear_about from "./hear_about";
import PreferredShiftTimeOfTheDay from "./PreferredShiftTimeOfTheDay";
import ErrorMsgModal from "../../../common/Modal/ErrorMsgModal";
import { mapDepartmentsToCandidate } from "../../../common/Modal/action";
import ListCard from "./ListCard";
import ItemCard from "./ItemCard";
import "./index.css"
import FormRegistration from "./FormRegistration";
import StatusUpdate from "./StatusUpdate";
import StatusTable from "./StatusTable";
import ResumeFile from "./ResumeFile";
import NoResumeHistory from "./NoResumeHistory";
const CandidateRating = ({ ratingValue }) => {
  let color = "";
  const val = ratingValue;
  if (val > 3) {
    color = 'green';
  } else if (val > 2 && val <= 3) {
    color = 'yellow';
  } else if (val > 0 && val <= 2) {
    color = 'red ';
  } else if (val <= 0) {
    color = 'black ';
  }
  const star = {
    size: 15,
    count: 5,
    value: ratingValue,
    edit: false,
    color: color,
    activeColor: color,
    a11y: true,
    isHalf: true,
    emptyIcon: <i className="fa fa-star-o" />,
    halfIcon: <i style={{ color: color }} className="fa fa-star-half-o" />,
    filledIcon: <i className="fa fa-star" />,
  };
  return <ReactStars {...star} />;

}
// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  const {
    data,
    masterData,
    candidateRating,
    dropDownJobId,
    candidateLocationStatus,
    loadingFlag,
  } = useSelector(candidateSearchViewSelector);

  const location = useLocation();
  const config = useConfiguration();
  const storage = useSessionStorage();
  const login = storage.getItem("login");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userData } = location.state || {};
  const { loctionId } = location.state || "";
  const { backpage } = location.state || "";
  const { locationNewStatus } = location.state || "";
  const [status, setStatus] = useState("");
  const [filterJobList, setFilterJobList] = useState({});
  const [showStatusWaring, setShowStatusWaring] = useState(false);
  const [selectedLocationStatus, setSelectedLocationStatus] = useState({
    candidateStatusForEmployer: 0,
    isFavorite: false,
    locationId: "",
    locationName: "",
    status: "",
    statusValue: "",
  });
  const [candidateStatus, setCandidateStatus] = useState({
    locationId: 0,
    statusId: 0,
  });

  const [emailModalInd, setEmailModalInd] = useState(false);
  const [emailModalData, setEmailModalData] = useState([]);
  const [smsModalInd, setSmsModalInd] = useState(false);
  const [smsModalData, setSmsModalData] = useState({});
  const [smsModalGetData, setSmsModalGetData] = useState({ sms: "" });
  const [emailModalGetData, setEmailModalGetData] = useState({ subject: "" });
  const [emailModalList, setEmailModalList] = useState([]);
  const [smsModalList, setSmsModalList] = useState([]);

  // Call state
  const [callModalInd, setCallModalInd] = useState(false);
  const [callModalData, setCallModalData] = useState([]);
  const [callModalGetData, setCallModalGetData] = useState({ subject: "" });
  const [callModalList, setCallModalList] = useState([]);
  const [callParams, setCallParams] = useState("");
  const [showDepartmentModal,setShowDepartmentModal] = useState({status:false,element:{},page:"candidatesearchview"});
  const [candidateName, setCandidateName] = useState('');
  const [currentDepStatusId,setCurrentDepStatusId] = useState(0)
  const [requestBodyUpdateStatus,setRequestBodyUpdateStatus] = useState({});
  const [retainEmployeeStatus, setRetainEmployeeStatus ] = useState("");
  const [updateStatusId, setUpdateStatusId] = useState(false);
  const [showErrorModal,setShowErrorModal] = useState(false);
  useEffect(() => {
    document.title = "Candidate Search View";
  }, []);

  const updateval = (target) => {
    setStatus(target.value);
  };

  useEffect(() => {
    if (config.baseUrl) {
      if (!login) {
        navigate("/");
      } else {
        if (userData && userData.candidateUniqueId) {
          const candidateRatingJson = {
            candidateUniqueId: userData.candidateUniqueId,
            jobUniqueId: "",
            locationId: 0,
            employerUniqueId: login.employerUniqueId,
          };

          dispatch(
            loadMasterData(`${config.baseUrl}`, login.employerUniqueId)
          ).then(() => {
            dispatch(
              getCandidateSearchViewDetail({
                url: `${config.baseUrl}/Candidates/get-candidate-infoV2`,
                candidateUniqueId: userData.candidateUniqueId,
                employerUniqueId: login.employerUniqueId,
              })
            ).then(() => {
              dispatch(
                getCandidateRating({
                  url: `${config.baseUrl}/Employers/get-candidate-rating_for_employer`,
                  params: candidateRatingJson,
                })
              );
            });
          });
          getCandidateLocationStatusList(location.state.loctionId);
        }
      }
    }
  }, [config]);

  const getCandidateLocationStatusList = (locationId) => {
    dispatch(
      getCandidateLocationStatus({
        url: `${config.baseUrl}/Candidates/get-employers-location-candidate-status-list`,
        params: {
          employerUniqueId: login.employerUniqueId,
          candidateUniqueId: userData?.candidateUniqueId,
        },
      })
    ).then((res) => {
      if (res?.statusHistory?.length === 0 && +locationNewStatus === 99) {
        setSelectedLocationStatus((previousData) => {
          return { ...previousData, locationId: locationId,statusValue: locationNewStatus};
        });
        return;
      }
      if (!res?.statusHistory?.length ||+locationNewStatus === 99) {
        setSelectedLocationStatus((previousData) => {
          return { ...previousData, locationId: locationId };
        });
        return;
      }
      const data = res.statusHistory.find(
        (element) => +element.locationId === +locationId
      );
      if(data?.statusValue) {
        setRetainEmployeeStatus(data?.statusValue)
      }
      setSelectedLocationStatus((previousData) => {
        return data;
      });
    });
  };

  // Page Refersh
  useEffect(() => {
    return () => {
      dispatch(clearData());
    };
  }, []);

  useEffect(() => {
    let filterVal = [];

    filterVal = login.jobTypeFlags.jobTypeList[0];
    if (filterVal) {
      setFilterJobList(filterVal);
    }
  }, [dropDownJobId]);

  const saveStatus = () => {
    if (!status) {
      Toasts.info("Please Select Status");
    } else {
      if (parseInt(status) === 99) {
        Toasts.info("Please Select Valid status other than New");
      } else {
        const requestResponse = {
          candidateUniqueId: userData?.candidateUniqueId,
          employerUniqueId: login.employerUniqueId,
          locationId: loctionId,
          appUserUniqueId: login.appUserUniqueId,
          candidateStatusForEmployer: parseInt(status),
          sourceWebsite: window.location.hostname,
        };
        dispatch(
          updateStatus({
            url: `${config.baseUrl}/Employers/updatecandidatestatusforemployer`,
            params: requestResponse,
          })
        );
      }
    }
  };
  const createStar_view = (count) => {
    let color = "";
    const val = count;
    if (val >= 4) {
      color = "green";
    } else if (val >= 3) {
      color = "yellow";
    } else if (val < 3 && val >= 0) {
      color = "red ";
    } else if (val <= 0) {
      color = "black ";
    }
    const star = {
      size: 25,
      count: 5,
      value: count,
      edit: false,
      color: color,
      activeColor: color,
      a11y: true,
      isHalf: true,
      emptyIcon: <i className="fa fa-star-o" />,
      halfIcon: <i className="fa fa-star-half-o" />,
      filledIcon: <i className="fa fa-star" />,
    };
    return <ReactStars {...star} />;
  };
  const getStarValue = (starValue) => {
    const requestBody = {
      candidateUniqueId: userData.candidateUniqueId,
      jobUniqueId: "",
      ratingNumber: starValue,
      ratingType: 1,
      ratingBy: login.appUserUniqueId,
      locationId: 0,
      employerUniqueId: login.employerUniqueId,
    };
    const candidateRatingJson = {
      candidateUniqueId: userData.candidateUniqueId,
      jobUniqueId: "",
      locationId: 0,
      employerUniqueId: login.employerUniqueId,
    };

    dispatch(
      setCandidateRating({
        url: `${config.baseUrl}/Ratings/save-candidate-rating`,
        params: requestBody,
      })
    );
  };

  const getCandidateUpdate = (locationId, statusId) => {
    if (!locationId) {
      toast.error("Please select Location");
      return;
    } else if (!statusId) {
      toast.error("Please select Status");
      return;
    } else if (parseInt(statusId) === 99) {
      Toasts.info("Please Select Valid status other than New");
      return;
    }
    let currentIndex = 0;
    if (selectedLocationStatus?.statusValue !== "") {
      currentIndex = masterData.statusList?.findIndex(
        (item) => item.id === +selectedLocationStatus?.statusValue
      );
    }
    const newIndex = masterData.statusList?.findIndex(
      (item) => item.id === parseInt(statusId)
    );

    if (newIndex > currentIndex + 1) {
      setCandidateStatus({ locationId, statusId });
      setShowStatusWaring(!showStatusWaring);
      return;
    } else {
      updateCandidateStatusFn(locationId, statusId);
    }
  };

  const updateCandidateStatusFn = (locationId, statusId) => {
    const requestBody = {
      candidateUniqueId: userData.candidateUniqueId,
      employerUniqueId: login.employerUniqueId,
      appUserUniqueId: login.appUserUniqueId,
      locationId: locationId,
      candidateStatusForEmployer: +statusId,
      sourceWebsite: window.location.hostname,
    };
    setRequestBodyUpdateStatus(requestBody);
    if(+statusId === 4 || +statusId === 5){
      setShowDepartmentModal(prev => ({...prev,status:true,element:{locationId,firstName:userData?.firstName, lastName:userData?.lastName,candidateUniqueId:userData?.candidateUniqueId}}));
      setCurrentDepStatusId(statusId)
      return
      }
    dispatch(
      updateCandidateStatus({
        url: `${config.baseUrl}/Employers/updatecandidatestatusforemployer`,
        params: requestBody,
      })
    ).then(() => {
      getCandidateLocationStatusList(locationId);
    });
  };

  const changeStatus = () => {
    updateCandidateStatusFn(
      candidateStatus.locationId,
      candidateStatus.statusId
    );
    hideStatusWaringModal();
  };

  const hideStatusWaringModal = () => {
    setShowStatusWaring(!showStatusWaring);
  };

  const changeCandidateFavorites = (locationId, isFavorite) => {
    if (!locationId) {
      toast.error("Please select Location");
      return;
    }

    const requestBody = {
      candidateUniqueIds: [userData.candidateUniqueId],
      employerUniqueId: login.employerUniqueId,
      appUserUniqueId: login.appUserUniqueId,
      locationId: locationId,
      isFavorite: isFavorite,
    };
    dispatch(
      updateCandidateFavorites({
        url: `${config.baseUrl}/Employers/set-candidate-favorite-status`,
        params: requestBody,
      })
    ).then(() => {
      getCandidateLocationStatusList(locationId);
    });
  };
  const createStar = (count) => {
    let color = "";
    const val = count;
    if (val > 3) {
      color = 'green';
    } else if (val > 2 && val <= 3) {
      color = 'yellow';
    } else if (val > 0 && val <= 2) {
      color = 'red ';
    } else if (val <= 0) {
      color = 'black ';
    }
    const star = {
      size: 15,
      count: 5,
      value: count,
      edit: false,
      color: color,
      activeColor: color,
      a11y: true,
      isHalf: true,
      emptyIcon: <i className="fa fa-star-o" />,
      halfIcon: <i style={{ color: color }} className="fa fa-star-half-o" />,
      filledIcon: <i className="fa fa-star" />,
    };
    return <ReactStars {...star} />;
  };

  const showEmailModal = async (data) => {
    getEmailModalData("subject", "");
    if (emailModalInd) {
      setEmailModalList([]);
    } else {
      const emailDetailsResult = await dispatch(
        getEmailDetails({
          url: `${config.baseUrl}/Messaging/get-email-messages/${data.candidateUniqueId}`,
        }),
      );
      if (Array.isArray(emailDetailsResult) && emailDetailsResult?.length) setEmailModalList(emailDetailsResult);
    }
    setEmailModalData((preVal) => [data]);
    setEmailModalInd((preVal) => !preVal);
  };

  const showSmsModal = async (data) => {
    setCandidateName(data?.name);
    if (smsModalInd) {
      setSmsModalList([]);
    } else {
      if (!!login?.verifiedPhoneNumber) {
        const params = {
          candidateUniqueId: data?.candidateUniqueId,
          employerMobileNumber: login.verifiedPhoneNumber,
          candidateMobileNumber: `${login.countryPhoneCode}${(data.phone)?.replace(/-/g, '')}`
        }
        const smsDetailsResult = await dispatch(
          getSMSDetails({
            url: `${config.baseUrl}/Messaging/get-sms-messages`, params
          }),
        );
        setSmsModalList(smsDetailsResult);
      } else {
        Toasts.error("SMS faciality not mapped to this employer.")
        return
      }
    }
    getSmsModalData("sms", "");
    setSmsModalData(data);
    setSmsModalInd((preVal) => !preVal);
  };

  const valueJoinWithComma = (inputValue, key) => {
    let returnValue = "";
    if (!inputValue) return returnValue;
    if (!key) {
      returnValue = inputValue.join(",");
    } else {
      returnValue = inputValue.map((e) => e[key]).join(",");
    }
    return returnValue;
  };

  const saveEmailModal = async (sessionUniqueId) => {
    const description = window.emailSummaryNoteValue();
    if (emailModalGetData.subject && description) {
      const requestBody = {
        candidateUniqueId: valueJoinWithComma(
          emailModalData,
          "candidateUniqueId",
        ),
        emailSubject: emailModalGetData.subject,
        messageBody: description,
        sessionId: sessionUniqueId,
        employerUniqueId: login?.employerUniqueId,
      };
      await dispatch(
        sendEmail({
          url: `${config.baseUrl}/Messaging/send-email-to-candidate`,
          params: requestBody,
        }),
      );
      showEmailModal();
    } else {
      toast.error('Subject field is required')
    }
  };

  const saveSmsModal = async () => {
    const requestBody = {
      candidateUniqueId: smsModalData.candidateUniqueId,
      messageBody: smsModalGetData.sms,
    };
    await dispatch(
      sendSMS({
        url: `${config.baseUrl}/Messaging/send-sms-to-candidate`,
        params: requestBody,
      }),
    );
    showSmsModal();
  };

  const getEmailModalData = (index, value) => {
    setEmailModalGetData((preVal) => {
      return {
        ...preVal,
        [index]: value,
      };
    });
  };

  const getSmsModalData = (index, value) => {
    setSmsModalGetData((preVal) => {
      return {
        ...preVal,
        [index]: value,
      };
    });
  };

  // Send ALL Email 
  const sendAllEmail = () => {
    dispatch(
      sendAllEmailbtn(`${config.baseMailUrl}/Messaging/sendallemails`)
    ).then((res) => {
      if (res.status === 200) {
        toast.success('Email sent successfully!')
      } else {
        toast.error('Email Not sent!')
      }
    })
    showEmailModal();
  };

  // Email Read
  const sendReadEmail = () => {
    if (config.baseUrl) {
      dispatch(sendAllEmailbtn(`${config.baseMailUrl}/Email/email-read-by-Graph`))
        .then((res) => {
          if (res.status === 200) {
            toast.success('Employer Email details updated successfully')
          } else {
            toast.error('Employer Email details are not updated')
          }
        })
    };
    showEmailModal();
  };

  // Send ALL SMS
  const sendAllSms = () => {
    dispatch(
      sendAllSmsbtn('https://development.overturexl.com/DevMessagingApi/api/Messaging/sendSMS')
    );
    showSmsModal();
  };

  // Call Modal 
  const showCallModal = (data) => {
    if (callModalInd) {
      setCallModalList([]);
    } else {
      const params = {
        phoneNumber: `${login.countryPhoneCode}${(data.phone || data?.cellPhoneNumber).replace(/-/g, '')}`
      }
      dispatch(getCallHistory(config.baseUrl, params)).then((callDetailsResult) => {
        if (Array.isArray(callDetailsResult) && callDetailsResult?.length) setCallModalList(callDetailsResult);
      })
      setCallParams({
        phoneNumber: data.phone || data?.cellPhoneNumber,
        candidateUniqueId: data.candidateUniqueId,
        jobsClaimId: 0,
        jobsShiftUniqueId: 0
      });
    }
    setCallModalData((preVal) => [data]);
    setCallModalInd((preVal) => !preVal);
  };

  // Once hangUP the Call that time Call History API Updated
  const getCallHistoryList = (phone) => {
    const params = {
      phoneNumber: `${(phone).replace(/-/g, '')}`
    }
    dispatch(getCallHistory(config.baseUrl, params)).then((callDetailsResult) => {
      if (Array.isArray(callDetailsResult) && callDetailsResult?.length) setCallModalList(callDetailsResult);
    })
  }
const updateTableData = (state,depsUnits) => {
  getCandidateLocationStatusList(state?.element?.locationId);
};
const updateStatusOfEmployer = (hasDepartment,showErrorMsg) => {
  if(hasDepartment){
    dispatch(
      updateCandidateStatus({
        url: `${config.baseUrl}/Employers/updatecandidatestatusforemployer`,
        params: requestBodyUpdateStatus,
      })
    ).then(() => {
      getCandidateLocationStatusList(requestBodyUpdateStatus?.locationId);
    });
  } else {
    if(showErrorMsg){
      setShowErrorModal(true);
    }
    setSelectedLocationStatus(prev => ({...prev, statusValue:retainEmployeeStatus}));
    setUpdateStatusId(!updateStatusId)
  }
}
const closeErrorModalHandler  = () => setShowErrorModal(false);
const updateEmpDepStatus = ({ mappedParams, isDepartmentsExist }) => {
  dispatch(
    updateCandidateStatus({
      url: `${config.baseUrl}/Employers/updatecandidatestatusforemployer`,
      params: requestBodyUpdateStatus,
    })
  ).then((response) => {
    if (response) {
      dispatch(mapDepartmentsToCandidate({ baseURL: config.baseUrl, mappedParams })).then((response) => {
        if (!isDepartmentsExist && !response) {
          dispatch(
            updateCandidateStatus({
              url: `${config.baseUrl}/Employers/updatecandidatestatusforemployer`,
              params: {
                ...requestBodyUpdateStatus,
                candidateStatusForEmployer: retainEmployeeStatus,
              },
            })
          ).then((response) => {
            if(response){
              updateStatusOfEmployer(false, true);
            }
          });
        } else {
          getCandidateLocationStatusList(requestBodyUpdateStatus?.locationId);
        }
      });
    } else {
      updateStatusOfEmployer(false);
    }
  });
};

  return (
    <div className="page main-margin">
      {/* <Loader /> */}
      {loadingFlag > 0 && <Spinner />}
      <Header />
      <Sidebar />
      {showErrorModal && <ErrorMsgModal errorMsg={"The candidate status is not updated. Please select a department to authorize."} closeHandler={closeErrorModalHandler}/>}
      {showDepartmentModal?.status && <DepsUnitsModal state= {showDepartmentModal} updateState = {setShowDepartmentModal} updateTableData={updateTableData} currentStatusId={currentDepStatusId} updateStatusOfEmployer={updateStatusOfEmployer} updateEmpDepStatus={updateEmpDepStatus} /> }
      <EmailModal
        showModal={emailModalInd}
        handleClose={showEmailModal}
        data={emailModalData}
        handleSave={saveEmailModal}
        handleForm={getEmailModalData}
        formData={emailModalGetData}
        listData={emailModalList}
        sendAllEmail={sendAllEmail}
        sendReadEmail={sendReadEmail}
      />
      <SMSModal
        showModal={smsModalInd}
        handleClose={showSmsModal}
        data={smsModalData}
        handleSave={saveSmsModal}
        formData={smsModalGetData}
        handleForm={getSmsModalData}
        listData={smsModalList}
        sendAllSms={sendAllSms}
        candidateName={candidateName}
      />
      <CallModal
        showModal={callModalInd}
        handleClose={showCallModal}
        listData={callModalList}
        phoneNumber={callParams.phoneNumber}
        candidateUniqueId={callParams.candidateUniqueId}
        getCallHistoryList={getCallHistoryList}
        jobsClaimId={callParams.jobsClaimId}
        jobsShiftUniqueId={callParams.jobsShiftUniqueId}
      />
      <div className="page-main">
        {showStatusWaring && (
          <Modal
            showHide={hideStatusWaringModal}
            label={"Alert"}
            size={"md"}
            center={true}
            saveFunction={changeStatus}
          >
            <span className="fw-bold">
              You are skipping an approval step and do you want to continue?
            </span>
          </Modal>
        )}
        {/* <BackFixedButton
          btnStyle={`btn-danger`}
          btnName={'Back'}
          backPage={backpage}
        /> */}
        <div className="main-content app-content mt-0 main-background">
          <div className="side-app">
            <div className="main-container container-fluid">
              <div className="page-header">
                <h1 className="page-title">Candidate Search</h1>
                <BackFixedButton
                  btnStyle={`btn-danger`}
                  btnName={"Back"}
                  backPage={backpage}
                  url={"candidatesearchview"}
                />
                {/* <div>
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="javascript:void(0)">Dashboard</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Locations
                    </li>
                  </ol>
                </div> */}
              </div>

              <div className="row">
                <div className="col-12">
                  <div className="card">
                    {/* <div className="card-header border-bottom-0">
                      <h3 className="card-title">Candidate details</h3>
                    </div> */}

                    {/* <div
                      className="col-md-12 col-xl-12"
                      style={{ margin: '0 0 0 25px' }}
                    >
                      <button
                        className="btn btn-danger"
                        onClick={() =>
                          navigate(backpage ? backpage : -1, {
                            state: {
                              fromBackUrl: true,
                            },
                          })
                        }
                      >
                        Back
                      </button>
                    </div> */}

                    <div className="card-body">
                      <div id="ReviewPage">
                        <div
                          className="col-md-12 col-xl-12"
                          style={{ display: "none" }}
                        >
                          <div className="card">
                            <div className="col-lg-12 col-md-12">
                              <div className="row">
                                <div className="card-header">
                                  <div className="PrintHeader">
                                    <b>
                                      <h3>Candidate Overture Status</h3>
                                    </b>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="card-body">
                              <div className="form-group">
                                <div className="row">
                                  <div className="col-lg-4 col-md-4">
                                    <input
                                      data-val="true"
                                      data-val-required="The CandidateId field is required."
                                      id="CandidateId"
                                      name="CandidateId"
                                      type="hidden"
                                      value="1000228"
                                    />
                                  </div>

                                  <div className="col-lg-3 col-md-3">
                                    <select
                                      className="form-select"
                                      name="status"
                                      onChange={(e) => {
                                        updateval(e.target);
                                      }}
                                    >
                                      <option value="">Select</option>
                                      {masterData.statusList.map((item) => (
                                        <option key={item.id} value={item.id}>
                                          {item.name}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                  <div className="col-lg-3 col-md-3">
                                    <button
                                      className="btn btn-primary"
                                      type="button"
                                      onClick={saveStatus}
                                    >
                                      Save
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* <CandidateDepartments
                            // tableData={
                            //   candidateLocationStatus?.statusHistory
                            //     ? candidateLocationStatus?.statusHistory
                            //     : []
                            // }
                          /> */}
                        <StatusUpdate
                          masterData={masterData}
                          getCandidateUpdate={getCandidateUpdate}
                          locationId={selectedLocationStatus?.locationId}
                          statusId={selectedLocationStatus?.statusValue}
                          isFavorite={selectedLocationStatus?.isFavorite}
                          changeCandidateFavorites={changeCandidateFavorites}
                          tableData={
                            candidateLocationStatus?.statusHistory
                              ? candidateLocationStatus?.statusHistory
                              : []
                          }
                          isStatusChanged = {updateStatusId}
                          positionsList={data?.jobCategoryIdList}
                          submitDate = {data?.submitProfileDateToDisplay}
                          creationDate = {data?.signupDateToDisplay}
                        />
                        {/* <CandidateStatusUpdate
                          masterData={masterData}
                          getCandidateUpdate={getCandidateUpdate}
                          locationId={selectedLocationStatus?.locationId}
                          statusId={selectedLocationStatus?.statusValue}
                          isFavorite={selectedLocationStatus?.isFavorite}
                          changeCandidateFavorites={changeCandidateFavorites}
                          tableData={
                            candidateLocationStatus?.statusHistory
                              ? candidateLocationStatus?.statusHistory
                              : []
                          }
                          isStatusChanged = {updateStatusId}
                        /> */}
                        {/* {!!candidateLocationStatus && (
                          <CandidateStatusTable
                            userData = {userData}
                            tableData={
                              candidateLocationStatus?.statusHistory ? candidateLocationStatus?.statusHistory : []
                            }
                            updateTableData={updateTableData}
                            candidateRating = {candidateRating}
                          />
                        )} */}
                        {!!candidateLocationStatus && (
                          <StatusTable
                            userData = {userData}
                            tableData={
                              candidateLocationStatus?.statusHistory ? candidateLocationStatus?.statusHistory : []
                            }
                            updateTableData={updateTableData}
                            candidateRating = {candidateRating}
                          />
                        )}
                        {/* <div>
                          <div>
                            <div className="card-body ps-0">
                              <div className="form-group">
                                <div className="row">
                                  <div className="col-lg-3 col-md-3">
                                    <h4 className="mb-0">Rating</h4>
                                  </div>
                                  <div className="col-lg-3 col-md-3">
                                    {candidateRating?.response?.ratingNumber ? <CandidateRating ratingValue={candidateRating?.response?.ratingNumber} /> : createStar(parseFloat(candidateRating?.response?.ratingNumber).toFixed(2))
                                    }
                                  </div>
                                  <div className="col-lg-3 col-md-3">
                                    Last Rating Date :
                                    {candidateRating && (
                                      <b>
                                        {
                                          candidateRating?.response
                                            ?.lastRatingDateToDisplay
                                        }
                                      </b>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div> */}
                        <div style={{display:"flex", flexDirection:"column", rowGap:"1.5rem"}}>
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(4,minmax(0,1fr))",
                            gap: "1.5rem",
                          }}
                        >
                          <FormRegistration
                            registrationData={data}
                            showSmsModal={showSmsModal}
                            showEmailModal={showEmailModal}
                            userData={userData}
                            showCallModal={showCallModal}
                          />
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-between",
                            }}
                          >
                           <div>
                            <h4 className="view-heading">Spoken Languages</h4>
                            <section>
                              <ul htmlFor="spokenLanguagesList">
                                {data?.spokenLanguagesList?.length > 0
                                  ? data?.spokenLanguagesList?.map((item) => item.name).join(" , ")
                                  : null}
                              </ul>
                            </section>
                          </div>
                          <div>
                            <h4 className="view-heading">Gender</h4>
                            <section>
                              <label style={{visibility:`${data?.gender ? 'visible':'hidden'}`}} htmlFor={"gender"}>{data?.gender ? data?.gender : 'gender'}</label>
                            </section>
                          </div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-between",
                            }}
                          >
                            <ResumeFile
                              resumeFileName={data?.resumeFileNameToDisplay}
                              fileId={data.candidateId}
                              noResume={data?.noResume}
                              candidateUniqueId = {userData?.candidateUniqueId}
                            />
                             <div>
                            <h4 className="view-heading">Level Of Education</h4>
                            <section>
                              <label style={{visibility:`${data?.levelofEducation ? 'visible':'hidden'}`}} htmlFor={"levelofEducation"}>{data?.levelofEducation ? data?.levelofEducation : 'levelofEducation'}</label>
                            </section>
                          </div>
                          </div>
                        </div>
                        <NoResumeHistory
                          educationList={data?.educationList}
                          workHistoryList={data?.workHistoryList}
                          noResume={data?.noResume}
                        />
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(4,minmax(0,1fr))",
                            gap: "1.5rem",
                          }}
                        >
                          <ItemCard
                            title={"Travel or Relocate"}
                            name={"relocateToDisplay"}
                            value={data?.relocateToDisplay}
                          />
                          <ItemCard
                            name={"covid19Vaccinated"}
                            title={"Covid 19 Vaccination Status"}
                            value={data?.covid19Vaccinated}
                          />
                          <div>
                            <h4 className="view-heading">Your References</h4>
                            <section>
                              <ul>
                                {data?.references?.map((item) => {
                                  return (
                                    <li>
                                      <label
                                        style={{
                                          display: "grid",
                                          gridTemplateColumns:"repeat(2,1fr)",
                                          columnGap: "1rem",
                                        }}
                                        htmlFor="references"
                                      >
                                        <span>
                                         {`${item?.firstName ?? ""} ${item?.lastName ?? ""}`}
                                        </span>
                                        <span> {item?.phoneNumber}</span>
                                      </label>
                                    </li>
                                  );
                                })}
                              </ul>
                            </section>
                          </div>
                          <div>
                            <h4 className="view-heading">Emergency Contact</h4>
                            <section>
                              <label
                                style={{
                                  display: "grid",
                                  gridTemplateColumns:"repeat(2,1fr)",
                                  columnGap: "1rem",
                                }}
                                htmlFor="emergencyContact"
                              >
                                <span>
                                  {`${data?.emergencyContact?.firstName ?? ""} ${data?.emergencyContact?.lastName ?? ""}`}
                                  {data?.emergencyContact?.relationship
                                    ? `(${data?.emergencyContact?.relationship})`
                                    : null}
                                </span>
                                <span>
                                  {" "}
                                  {data?.emergencyContact?.phoneNumber}
                                </span>
                              </label>
                            </section>
                          </div>
                          <ItemCard
                            name={"travelDistance"}
                            title={"Travel Distance"}
                            value={data?.travelDistance}
                          />
                           <div >
                            <h4 className="view-heading">Lead Source</h4>
                            <section className="d-flex ">
                              <label className="flex-1 w-100" htmlFor={"referenceSource"}>{data?.referenceSource}</label>
                              <label className="flex-1 w-100" htmlFor={"referenceSource"}>{data?.referenceSourceOther}</label>
                            </section>
                          </div>
                          {/* <ItemCard title={"Test Reason"} name={"testReason"} /> */}
                          {(filterJobList?.showSpecialties || filterJobList?.showEmr) ? (
                            <>
                             <div></div>
                             <div></div>
                            </>) : (
                              <>
                              <ItemCard
                              title={"Hours Worked"}
                              name={"hoursWorked"}
                              value={data?.hoursWorked}
                            />
                            <ItemCard
                              title={"Shifts Completed"}
                              name={"shiftsCompleted"}
                              value={data?.shiftsCompleted}
                            />
                              </>
                            )}
                          
                          {/* {filterJobList?.showSpecialties && (
                            <ListCard
                              title={"Medical Specialties"}
                              name={"specialtyList"}
                              listItems={data?.specialtyList}
                            />
                          )} */}
                          {filterJobList?.showSpecialties && (
                            <div style={{gridColumn:'span 2'}}>
                             <div style={{
                                  display: "grid",
                                  gridTemplateColumns:"repeat(2,1fr)",
                                  columnGap: "1rem",
                                }}>
                             <h4 className="view-heading">
                                Medical Specialties
                              </h4>
                             <h4 className="view-heading">
                                Years of Experience
                              </h4>
                             </div>
                              <section>
                                <ul htmlFor="specialtyList">
                                  {data?.specialtyList?.length > 0
                                    ? data?.specialtyList?.map((item) => (
                                       <li  style={{
                                        display: "grid",
                                        gridTemplateColumns:"repeat(2,1fr)",
                                        columnGap: "1rem",
                                      }}>
                                         <span>{item.name}</span>
                                         <span>{item.yearsOfExperience}</span>
                                       </li>
                                      ))
                                    : null}
                                </ul>
                              </section>
                            </div>
                          )}
                          {filterJobList?.showEmr && (
                            <ListCard
                              title={"EMR/EHR Systems"}
                              name={"emrehrSystemList"}
                              listItems={data?.emrehrSystemList}
                            />
                          )}
                          {
                            (filterJobList?.showSpecialties || filterJobList?.showEmr) ?  <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-between",
                            }}
                          >
                            <ItemCard
                              title={"Hours Worked"}
                              name={"hoursWorked"}
                              value={
                                +data?.hoursWorked <= 1
                                  ? `${data?.hoursWorked} Hour`
                                    : +data?.hoursWorked > 1
                                    ? `${data?.hoursWorked} Hours`
                                  : data?.hoursWorked
                              }
                            />
                            <ItemCard
                              title={"Shifts Completed"}
                              name={"shiftsCompleted"}
                               value={
                                +data?.shiftsCompleted <= 1
                                  ? `${data?.shiftsCompleted} Shift`
                                    : +data?.shiftsCompleted > 1
                                    ? `${data?.shiftsCompleted} Shifts`
                                  : data?.shiftsCompleted
                              }
                            />
                          </div> : null
                          }
                       
                          <ListCard
                            title={"Preferred Work Days"}
                            name={"preferredWorkDaysList"}
                            listItems={data?.preferredWorkDaysList}
                          />
                          <ListCard
                            title={"Preferred Shift Time of the Day"}
                            name={"preferredShiftTimeOfTheDaysList"}
                            listItems={data?.preferredShiftTimeOfTheDaysList}
                          />
                          <ListCard
                            title={"Preferred Shifts"}
                            name={"preferredShiftList"}
                            listItems={data?.preferredShiftList}
                          />
                          <ListCard
                            title={"Holidays Willing to Work"}
                            name={"preferredHolidaysToWorkList"}
                            listItems={data?.preferredHolidaysToWorkList}
                          />
                        </div>
                        </div>
                        {/* <RegistrationForm registrationData={data} showSmsModal={showSmsModal}
                          showEmailModal={showEmailModal} userData={userData} showCallModal={showCallModal} />
                        <div className="row">
                          <div className="col-xl-6 col-md-6">
                            <EmergencyContact
                              emergencyData={data?.emergencyContact}
                            />
                          </div>
                          <div className="col-xl-6 col-md-6">
                            <YourReferences references={data?.references} />
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-xl-6 col-md-6">
                            <SpokenLanguage
                              spokenLanguagesList={data?.spokenLanguagesList}
                            />
                    
                          </div>
                          <div className="col-xl-6 col-md-6">
                            <Positions
                              PositionsList={data?.jobCategoryIdList}
                            />
                          </div>
                        </div>

                        <div className="row">
                        <div className="col-xl-6 col-md-6">
                        <Relocate
                              relocate={data?.relocateToDisplay}
                            />
                        </div>
                          <div className="col-xl-6 col-md-6">
                        <Hear_about referenceSource={data?.referenceSource} />
                        </div>
                        </div>

                        <ResumeUpload
                          resumeFileName={data?.resumeFileName}
                          educationList={data?.educationList}
                          workHistoryList={data?.workHistoryList}
                          fileId={data.candidateId}
                          noResume={data?.noResume}
                        /> */}

                        {/* {filterJobList?.showCertifications && (
                          <>
                            <Certifications
                              certificationsList={data?.certificationsList}
                              certificationsListOther={
                                data?.certificationsListOther
                              }
                            />
                          </>
                        )} */}
                        {filterJobList?.showCertifications && (
                          <>
                            <NewCertifications data={data} getCandidateLocationStatusList={getCandidateLocationStatusList}/>
                          </>
                        )}
                        {/* <div className="row">
                          <div className="col-xl-6 col-md-6">
                            <LevelOfEducation
                              levelofEducation={data?.levelofEducation}
                            />
                          </div>
                          <div className="col-xl-6 col-md-6">
                            <PreferredShifts
                              preferredShiftList={data.preferredShiftList}
                            />
                          </div>
                        </div>

                        {filterJobList?.showSpecialties && (
                          <>
                            <YourSpecialties
                              specialtyList={data?.specialtyList}
                            />
                          </>
                        )}
                        {filterJobList?.showEmr && (
                          <>
                            <EmrandehrSystem
                              emrehrSystemList={data?.emrehrSystemList}
                              emrehrSystemListOther={
                                data?.emrehrSystemListOther
                              }
                            />
                          </>
                        )}

                        <div className="row">
                          <div className="col-xl-6 col-md-6">
                            <TravelDistance
                              travelDistance={data?.travelDistance}
                            />
                          </div>
                          <div className="col-xl-6 col-md-6">
                            <Covid19vaccinated
                              covid19Vaccinated={data?.covid19Vaccinated}
                            />
                          </div>
                        </div>

                        <PreferredWorkDays
                          preferredWorkDaysList={data?.preferredWorkDaysList}
                        />
                        <PreferredShiftTimeOfTheDay 
                              preferredShiftTimeOfTheDaysList={data?.preferredShiftTimeOfTheDaysList}
                        />
                        <Willingworkholidays
                          preferredHolidaysToWorkList={
                            data?.preferredHolidaysToWorkList
                          }
                        /> */}

                        {login?.accountFlags?.isShowQATab && (
                          <>
                            <QandaTaForm
                              data={data}
                              userData={userData}
                              qaTabDynamicDataV2={data?.qaTabDynamicDataV2}
                              getCandidateLocationStatusList={getCandidateLocationStatusList}
                            />
                          </>
                        )}
                        <EmployerUploads />

                        <CommentSummry
                          data={data}
                          userData={userData}
                          CommentSummry_candidateUniqueId={
                            userData?.candidateUniqueId
                          }
                        //covid19Vaccinated={data?.covid19Vaccinated}
                        />
                        <div>
                          {/* <button
                            className="btn btn-danger"
                            onClick={() =>
                              navigate(backpage ? backpage : -1, {
                                state: {
                                  fromBackUrl: true,
                                },
                              })
                            }
                          >
                            Back
                          </button> */}
                        </div>
                        <a
                          href="#top"
                          id="back-to-top"
                          style={{ bottom: "7.5rem" }}
                        >
                          <i className="fa fa-angle-up"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="pull-right mb-3">
                    <BackFixedButton
                      btnStyle={`btn-danger`}
                      btnName={"Back"}
                      backPage={backpage}
                      url={"candidatesearchview"}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
